<template>
    <section class="sc-dashboard">
        <div class="container flex-wrapper">
            <main class="main-content layout-calc">
                <!-- TARIFF ACCOUNT RESOURCES -->
                <div v-if="resources.tariffPlan.groups && resources.tariffPlan.groups.length">
                    <div class="progress-bar-chart-wrapper">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <h2>{{ tariffName.toUpperCase() }}</h2>
                            </li>
                        </ul>
                        <!-- Loop through each group -->
                        <div v-for="group in resources.tariffPlan.groups" :key="group.id">
                            <TariffPlan
                                v-for="(tariffAccount, index) in group.items"
                                :key="index"
                                :account="tariffAccount"
                                :is-grouped="!!group.name"
                            />
                        </div>
                    </div>
                </div>
                <!-- BUNDLE ACCOUNT RESOURCES -->
                <div v-if="resources.bundleAccount.groups && resources.bundleAccount.groups.length">
                    <div class="progress-bar-chart-wrapper">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <h2>{{ $t('pages.resources.bundleAccount') }}</h2>
                            </li>
                        </ul>
                        <!-- Loop through each group -->
                        <div v-for="group in resources.bundleAccount.groups" :key="group.id">
                            <BundleAccount
                                v-for="(bundleAccount, index) in group.items"
                                :key="index"
                                :account="bundleAccount"
                                :is-grouped="!!group.name"
                            />
                        </div>
                    </div>
                </div>
                <!-- LOYALTY ACCOUNT RESOURCES -->
                <div v-if="resources.loyalty && resources.loyalty.groups && resources.loyalty.groups.length">
                    <div class="progress-bar-chart-wrapper">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <h2>{{ $t('pages.resources.loyalty') }}</h2>
                            </li>
                        </ul>
                        <!-- Loop through each group -->
                        <div v-for="group in resources.loyalty.groups" :key="group.id">
                            <Loyalty
                                v-for="(loyaltyAccount, index) in group.items"
                                :key="index"
                                :account="loyaltyAccount"
                                :is-grouped="!!group.name"
                            />
                        </div>
                    </div>
                </div>
                <!-- OTHER RESOURCES (catch-all bucket, e.g. BONUS-category data packages) -->
                <div v-if="resources.other.groups && resources.other.groups.length">
                    <div class="progress-bar-chart-wrapper">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <h2>{{ $t('pages.resources.other') }}</h2>
                            </li>
                        </ul>
                        <!-- Loop through each group -->
                        <div v-for="group in resources.other.groups" :key="group.id">
                            <BundleAccount
                                v-for="(otherAccount, index) in group.items"
                                :key="index"
                                :account="otherAccount"
                                :is-grouped="!!group.name"
                            />
                        </div>
                    </div>
                </div>
                <!-- EMPTY STATE: successful load with no renderable resources -->
                <div v-if="loaded && !hasResources" class="resources-empty-state">
                    <p>{{ $t('pages.resources.noResources') }}</p>
                </div>
            </main>
        </div>
    </section>
</template>

<script>
import Resources from './Resources';
export default Resources;
</script>

<style scoped>
.resources-empty-state {
    text-align: center;
    margin: 50px;
    color: #6c757d;
}
</style>
